import script from "./DeliveryGeneralChecksCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryGeneralChecksCard.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryGeneralChecksCard.vue?vue&type=style&index=0&id=36f6b218&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f6b218"]])

export default __exports__